import { MainContent, TopBar } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Admin/components/MainNavigation'

import AnalyticsRoutes from './routes'

const Dashboard = () => {
  const {
    callbacks: { toggleNavigation },
  } = useMainNavigation()

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        searchComponent={
          <DashboardSearch searchEntities={['LayoutTemplate', 'TaskList', 'TemplatePage', 'TemplatePagePartial']} />
        }
      />

      <MainNavigation />

      <MainContent offset={{ top: TopBar.topBarHeight }}>
        <AnalyticsRoutes />
      </MainContent>
    </>
  )
}

export default Dashboard
